<!-- unfinished, kept for different filters layout -->
<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          label="Search"
          prepend-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </v-col>
      <v-col>
        <v-btn class="ma-2" @click="addNewPerson">Add New Person</v-btn>
      </v-col>
    </v-row>

    <v-card flat>
      <v-dialog v-model="dialogFilter" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn small v-on="on" class="ma-2">Add Filter</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Add Filter</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    :items="filterOptions"
                    item-text="text"
                    item-value="value"
                    label="Name"
                    v-model="selectedFilterName"
                    @change="resetFilterValue"
                  ></v-select>
                  <v-text-field
                    label="Value"
                    v-model="newFilterValue"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogFilter = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="applyFilter">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <BaseMitDataTable
      title="People List"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[10, 20, 50, 100]}"
      :headers="headers"
      :items="filteredPeople"
      :editable="false"
      :showExpanded="true"
      @pagination="updatePagination"
    >
      <template v-slot:item.location="{ item }">
        <v-btn text @click="openDialog(item)">
          {{ item.location.spaceId || (item.location.needsSetup === 'Yes' ? 'Needs setup' : 'Does not need space') }}
        </v-btn>
      </template>

      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="`/user/${item.csailId}`">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>

      <template v-slot:expanded-item="{ item }">
        <td class="pa-1" :colspan="headers.length">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col>
                  <h4>Details for {{ item.fname }} {{ item.lname }}</h4>
                  <p><strong>MIT ID:</strong> {{ item.mitId }}</p>
                  <p><strong>CSAIL ID:</strong> {{ item.csailId }}</p>
                  <p><strong>Location:</strong> {{ item.location.spaceId || 'N/A' }}</p>
                  <p><strong>Setup Comments:</strong> {{ item.location.setupComments || 'No comments available' }}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </td>
      </template>

      <template v-slot:no-data>
        <v-alert type="warning">No people found.</v-alert>
      </template>
    </BaseMitDataTable>

    <v-alert v-if="loading" type="info">Loading people data...</v-alert>

    <!-- Comments dialog-->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Comments</span>
        </v-card-title>
        <v-card-text>
          {{ selectedComments || 'No comments available' }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MitPeopleService from '../../services/MitPeopleService';
import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
// import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
// import AddNewPersonDialog from 'MitManageAddNewPersonDialog.vue';

export default {
  name: 'MitManagePeopleList2',
  components: {
    BaseMitDataTable,
  },
  data() {
    return {
      search: "",
      people: [],
      loading: true,
      dialog: false,
      dialogFilter: false,
      selectedComments: null,
      selectedFilterName: null, 
      newFilterValue: '', 
      filterOptions: [
        { text: 'Last Name', value: 'lname' },
        { text: 'CSAIL ID', value: 'csailId' },
        { text: 'MIT ID', value: 'mitId' },
        { text: 'First Name', value: 'fname' },
        { text: 'Members with Rooms Assigned', value: 'roomsAssigned' },
        { text: 'Members without Rooms Assigned', value: 'noRoomsAssigned' }, 
      ],
      headers: [
        { text: "First Name", value: "fname" },
        { text: "Last Name", value: "lname" },
        { text: "MIT ID", value: "mitId" },
        { text: "CSAIL ID", value: "csailId" },
        { text: "Location", value: "location" },
      ],
      paging: {
        page: 1,
        pageSize: 25,
        totalItems: 0
      },
      expandedItem: null 
    };
  },
  computed: {
    filteredPeople() {
      let filtered = this.people;

      // Filter by search
      if (this.search) {
        filtered = filtered.filter(person => {
          return (
            person.fname.toLowerCase().includes(this.search.toLowerCase()) ||
            person.lname.toLowerCase().includes(this.search.toLowerCase()) ||
            person.mitId.toLowerCase().includes(this.search.toLowerCase()) ||
            person.csailId.toLowerCase().includes(this.search.toLowerCase()) ||
            (person.location.spaceId && person.location.spaceId.toLowerCase().includes(this.search.toLowerCase())) ||
            (person.location.setupComments && person.location.setupComments.toLowerCase().includes(this.search.toLowerCase()))
          );
        });
      }

      // Apply additional filters
      if (this.selectedFilterName === 'roomsAssigned') {
        filtered = filtered.filter(person => 
          person.location && person.location.spaceId && person.location.spaceId.trim() !== ''
        );
      } else if (this.selectedFilterName === 'noRoomsAssigned') {
        filtered = filtered.filter(person => 
          (!person.location.spaceId || person.location.spaceId.trim() === '') &&
          (!this.newFilterValue || person.location.setupComments && 
           person.location.setupComments.toLowerCase().includes(this.newFilterValue.toLowerCase()))
        );
      } else if (this.selectedFilterName) {
        filtered = filtered.filter(person => {
          return person[this.selectedFilterName] && 
                 person[this.selectedFilterName].toString().toLowerCase().includes(this.newFilterValue.toLowerCase());
        });
      }

      return filtered; 
    },
  },
  created() {
    this.loadPeople();
  },
  methods: {
    async loadPeople() {
      try {
        this.loading = true;
        const response = await MitPeopleService.getPeople();
        this.people = response; 
        this.paging.totalItems = this.people.length; 
        console.log("Loaded people:", this.people); 
      } catch (error) {
        console.error("Error loading people:", error);
      } finally {
        this.loading = false;
      }
    },
    openDialog(item) {
      if (item.location.needsSetup === 'Yes') {
        this.selectedComments = item.location.setupComments;
        this.dialog = true;
      } else {
        this.selectedComments = null; 
      }
    },
    // change later t a dialog or link to a new "add person page"
    addNewPerson() {
      alert("Add New Person.");
    },
    applyFilter() {
      this.dialogFilter = false; 
    },
    updatePagination(pagination) {
      this.paging.page = pagination.page;
      this.paging.pageSize = pagination.itemsPerPage;
    },
    resetFilterValue() {
      this.newFilterValue = ''; 
    },
    toggleExpand(item) {
      this.expandedItem = this.expandedItem === item ? null : item; 
    },
  },
};
</script>

<style scoped>
.elevation-1 {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
</style>
